import React from "react";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";

export default (props) => (
  <div>
      <Typography variant='subtitle1' align='center'>
        &copy; 2020 Research of a System for Βias Identification in Machine
        Learning, University of Patras
      </Typography>
    
  </div>
);
